import { DatePicker, DefaultButton, Dialog, DialogFooter, DialogType, MessageBar, MessageBarType, PrimaryButton, ProgressIndicator, Stack, TextField } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule';
import { IEventScheduleList } from '../../../../../Models/Event/IIEventScheduleList';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventSchedulesApi } from '../../../../../Services/API/EventSchedules/IEventSchedulesApi';
import * as Services from '../../../../../Services/Services';
import { dateToStr } from '../../../../../Tools/DateTime';

interface IAddEventSheduleProps {
    eventSchedule?: IEventScheduleList;
    isOpened: boolean;
    onDismiss: () => void;
    refresh: () => void;
}

const dialogContentProps = {
    type: DialogType.normal,
    title: 'Vytvoření události',
    closeButtonAriaLabel: 'Close',
    subText: 'Zadejte datum konání',
};
const dialogStyles = { main: { maxWidth: 450 } };

export const AddUpdateEventSchedule: React.FunctionComponent<IAddEventSheduleProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [description, setDescription] = React.useState<string>();
    const [lessons, setLessons] = React.useState<number>(1);
    const [date, setDate] = React.useState<Date>(new Date(Date.now()))


    React.useEffect(() => {
        if (props.eventSchedule) {
            setDescription(props.eventSchedule.description);
            setDate(props.eventSchedule.date);
        }
    }, [])


    const labelId: string = useId('dialogLabel');
    const subTextId: string = useId('subTextLabel');
    const modalProps = {
        titleAriaId: labelId,
        subtitleAriaId: subTextId,
        isBlocking: false,
        styles: dialogStyles,
    }




    const CreateEventSchedule = async () => {
        if (props.eventSchedule) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
            const result = await schedulesApi.addEventSchedule({
                date: dateToStr(date),
                eventId: props.eventSchedule.eventId,
                description: description
            });
            if (result.isSuccess && result.data) {
                props.refresh();
                props.onDismiss();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }

    const UpdateEventSchedule = async () => {
        if (props.eventSchedule) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
            const result = await schedulesApi.udateEventSchedule({
                id: props.eventSchedule.id,
                date: dateToStr(date),
                eventId: props.eventSchedule.eventId,
                description: description
            });
            if (result.isSuccess && result.data) {
                props.refresh();
                props.onDismiss();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }


    const saveEventSchedule = async () => {
        if (props.eventSchedule?.id === 0) {
            await CreateEventSchedule();
        }
        else {
            UpdateEventSchedule();
        }
    }

    return (<><Dialog
        hidden={!props.isOpened}
        onDismiss={props.onDismiss}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}>
        <Stack tokens={{ childrenGap: 10 }}>
            <DatePicker label="Datum konání" value={date} onSelectDate={(date: Date | null | undefined) => { setDate(date ? date : new Date(Date.now())) }} />
            <TextField multiline label="Popis činnosti" value={description} onChange={(e, v) => setDescription(v)} />
        </Stack>
        <Stack styles={{ root: { height: 10 } }}>
            {isLoading ? <ProgressIndicator /> : null}
        </Stack>
        {statusMessage ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
        <DialogFooter>
            <PrimaryButton onClick={saveEventSchedule} text={props.eventSchedule?.id === 0 ? "Vytvořit" :"Upravit"} />
            <DefaultButton onClick={props.onDismiss} text="Zrušit" />
        </DialogFooter>
    </Dialog></>)
}
